import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { RoutePaths } from '../../constants';
import confettiDesktop from '../../images/confetti_desktop.svg';
import confettiMobile from '../../images/confetti_mobile.svg';
import { NavigationElements } from '../../components/Navigation';
import { WebAppLayout } from '../../layouts/WebAppLayout';
import { HeaderElements } from '../../components/Header/Header.types';
import { Stack, Icon } from '../../components/UI';

import './NewPromptSuccessPage.scss';

const b = cn('new-prompt-success-page');

export const NewPromptSuccessPage = () => {
    const navigationElements: NavigationElements = {
        desktop: [
            {
                text: 'Смотреть мои промпты',
                to: RoutePaths.ProfilePrompts,
                accent: true,
            },
        ],
        mobile: [
            {
                text: 'Перейти',
                to: RoutePaths.ProfilePrompts,
                accent: true,
            },
        ],
    };

    const headerElements: HeaderElements = {
        desktop: {
            left: {
                type: 'logo',
            },
            right: {
                type: 'profile',
            },
        },
        mobile: {
            right: {
                type: 'custom',
                render: () => {
                    return (
                        <Link to={RoutePaths.Main}>
                            <Icon name="close" size={24} />
                        </Link>
                    );
                },
            },
        },
    };

    return (
        <WebAppLayout navigationElements={navigationElements} headerElements={headerElements}>
            <Stack className={b()}>
                <img src={confettiDesktop} alt="Конфетти" className={b('confetti', { desktop: true })} />
                <img src={confettiMobile} alt="Конфетти" className={b('confetti', { mobile: true })} />
                <div className={b('like')}>
                    <Icon name="like" size={32} fillColor="var(--accent-color)" className={b('like-icon')} />
                </div>
                <h1 className={b('title')}>
                    Отлично!
                    <br />
                    Заявка на&nbsp;модерации
                </h1>
                <p className={b('subtitle')}>Отслеживайте статус на&nbsp;странице своих промптов</p>
                {/* <p className={b('subtitle')}>Промпт появится на сайте после модерации</p> */}
            </Stack>
        </WebAppLayout>
    );
};
